import { useState } from "react";

export function CookieNotice() {
  const [visible, setVisible] = useState(
    () => localStorage.getItem("vg_cookie_notice") !== "seen",
  );
  if (!visible) return null;
  return (
    <aside className="cookie-notice" aria-label="Informativa cookie">
      <p>
        Usiamo solo cookie tecnici per profilo e VAFFA. Niente pubblicità e
        niente tracciamento.
      </p>
      <a href="/cookie">Dettagli</a>
      <button
        type="button"
        onClick={() => {
          localStorage.setItem("vg_cookie_notice", "seen");
          setVisible(false);
        }}
      >
        Va bene
      </button>
    </aside>
  );
}
